import { useQuery } from '@tanstack/react-query';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface TimesheetSummaryParams {
  year: number;
  weekId: number;
  onlyMyTeam?: boolean;
}

/** @registry Per-workflow-step timesheet counts that label the Time page tabs. */
export function useTimesheetSummary(
  officeId: number | null | undefined,
  params: TimesheetSummaryParams,
) {
  return useQuery({
    queryKey: queryKeys.timesheets.summary(officeId ?? -1, params),
    queryFn: ({ signal }) =>
      timesheetApiClient.getTimeSummary(
        officeId!,
        params.year,
        params.weekId,
        params.onlyMyTeam,
        toCancelToken(signal),
      ),
    enabled: officeId != null && officeId > 0,
    staleTime: 0,
    meta: { errorContext: 'time summary' },
  });
}
